import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

export class langSel{
  clave: string;
  name: string;
  id: number;
  color: string;
  langDestino: number;
  constructor(){}
};

@Component({
  selector: 'modalIdioma',
  templateUrl: 'modalIdioma.component.html',
  styleUrls: ['./idiomas.component.scss']
})

export class ModalIdioma {

  //idiomas provenientes del component idiomas
  langs: any[] = [];

  //guarda el idioma principal seleccionado
  langIdSel = new langSel();

  //guarda la lista de idiomas adicionales seleccionados
  langIdSelAdic: langSel[] = [];

  //booleano para habilitar boton "listo" al seleccionar idioma principal
  langBool = false;

  constructor(
      public dialogRef: MatDialogRef<ModalIdioma>,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      lang_certificar.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.langs = data.langs;
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selLangId(lang: any, langDestino: any)
  {
    this.langIdSel.clave = lang.clave;
    this.langIdSel.name = lang.nombre;
    this.langIdSel.id = lang.id;
    this.langIdSel.color = 'warn';
    this.langIdSel.langDestino = langDestino;
    this.langBool = true;
  }
  selLangIdAd(lang: any, langDestino: any)
  {
    let idiomaSel: any = {clave: lang.clave, name: lang.nombre, id: lang.id, color: 'warn', langDestino: langDestino};
    if(this.langIdSelAdic.length == 0){
      this.langIdSelAdic.push(idiomaSel);
      this.langBool = true;
    }
    else{
      let iter = 0;
      let fnd = false;
      this.langIdSelAdic.forEach((elem) => {
        if(elem.id == idiomaSel.id){
          this.langIdSelAdic.splice(iter,1);
          fnd = true;
        }
        iter++;
      });
      if(!fnd)
        this.langIdSelAdic.push(idiomaSel);
    }
  }


}
